import React, { useEffect, useState } from "react";
import DocumentSection from "./DocumentSection";
import { useSelector, useDispatch } from "react-redux";
import { getMasterConfigID } from '@src/store/slices/common';
import { CREATE_PAGE_INDEX } from "@src/config/id/constant";
import { useLanguage } from "@src/context/LanguageContext";

const Docs = ({ documentList = [], setSectionItem, handleSubmit, requestData,isEdit, setLoading, setDeletedDocs,sectionList, uploadDocumentNow,setRequestData}: any) => {
  const [masterConfig,setMasterConfig] = useState<any>(null);

   const commonState = useSelector((state: any) => state.common)
   const dispatch: any = useDispatch()
   const {translations} = useLanguage();
 
  /* Fetch master config if not in redux */
  useEffect(() => {
    if (!commonState?.masterConfig) {
      dispatch(getMasterConfigID());
    } else {
      setMasterConfig(commonState.masterConfig);
    }
  }, [commonState?.masterConfig, dispatch]);


  return (
    <>
    <div className="doc-upload-outer-id">
      <h3> {translations?.COMMON_MSG?.DOC_UPLOAD} </h3>
      <div className="row">
        {documentList.map((doc:any, index:number) => (
          <DocumentSection
            key={doc.value}
            document={doc}
            index={index}
            sectionItem={documentList}
            setSectionItem={setSectionItem}
            setLoading={setLoading}
            masterConfig={masterConfig}
            requestData = {requestData}
            isEdit= {isEdit}
            setDeletedDocs= {setDeletedDocs}
            setRequestData ={setRequestData}
            uploadDocumentNow={uploadDocumentNow}
          />
        ))}
      </div>

      <div className="btn-continue btn-bottom-fixed">
        <button className="btn-primary" onClick={() => handleSubmit(CREATE_PAGE_INDEX.DOC)}>{sectionList?.[CREATE_PAGE_INDEX.DOC]?.btn?.title}</button>
      </div>
      </div>
    </>
  );
};

export default Docs;
